import {
  dateTimeFormatter, localeFormatter,
  statusFormatter,
  userPositionFormatter,
  userShortFIOFormatter,
} from '../../../utils/formatters';
import { FILTER_TEMPLATE_STATUS_NAMES } from '../../../configs';

export const columnSettings = [
  {
    dataField: 'name',
    text: 'Наименование шаблона фильтра',
    headerClassName: '',
  },
  {
    dataField: 'page',
    text: 'Применение шаблона фильтра',
    headerClassName: '',
    formatter: a => localeFormatter('menu', a),
  },
  {
    dataField: 'created_at',
    text: 'Дата создания',
    headerClassName: 'created-at-big',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'causer',
    text: 'Автор',
    headerClassName: 'user-column',
    formatter: userShortFIOFormatter,
  },
  {
    dataField: 'is_active',
    text: 'Статус',
    formatter: a => statusFormatter(+a, 'filter.template.is_active', FILTER_TEMPLATE_STATUS_NAMES),
  },
];
